// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagina-clientes.contenedorprincipal {
  width: 95%;
  margin: 0 auto;
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
}

.pagina-clientes .titulo {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 2px;
}

.pagina-clientes .botonessuperiores {
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-bottom: 15px;
}

.pagina-clientes .botonessuperiores .p-button {
  padding: 5px 10px;
  font-size: 14px;
}

/* [EXPERT] Estabilidad y Altura Fija */
.pagina-clientes .p-datatable .p-datatable-wrapper {
  min-height: 400px;
}

.pagina-clientes .p-datatable .p-datatable-thead > tr > th {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.35rem !important;
}

.pagina-clientes .p-datatable .p-datatable-tbody > tr > td {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.3rem !important;
  height: 38px !important; /* Altura firme alineada con el resto de la app */
}

/* ============================================
   MEDIA QUERIES - RESPONSIVIDAD
   ============================================ */

/* === TABLETS (1024px y menores) === */
@media (max-width: 1024px) {
  .pagina-clientes.contenedorprincipal {
    width: 98%;
  }

  .pagina-clientes .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.8rem;
    padding: 0.25rem !important;
  }

  .pagina-clientes .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.85rem;
    padding: 0.25rem !important;
    height: 36px !important;
  }
}

/* === MÓVILES (768px y menores) === */
@media (max-width: 768px) {
  .pagina-clientes.contenedorprincipal {
    width: 100%;
    padding: 5px;
  }

  .pagina-clientes .titulo {
    font-size: 1.2rem;
  }

  .pagina-clientes .botonessuperiores {
    flex-direction: column;
    gap: 8px;
  }

  .pagina-clientes .botonessuperiores .p-button {
    width: 100%;
    justify-content: center;
  }

  .pagina-clientes .p-datatable-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* === MÓVILES PEQUEÑOS (480px y menores) === */
@media (max-width: 480px) {
  .pagina-clientes .titulo {
    font-size: 1rem;
  }

  .pagina-clientes .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.75rem;
  }

  .pagina-clientes .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.75rem;
    height: 32px !important;
  }
}

/* Selección de fila */
.pagina-clientes .p-datatable .p-datatable-tbody > tr.p-highlight {
  background-color: #e0f7fa !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/clientes.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB,EAAE,iDAAiD;AAC5E;;AAEA;;iDAEiD;;AAEjD,uCAAuC;AACvC;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;AACtC","sourcesContent":[".pagina-clientes.contenedorprincipal {\n  width: 95%;\n  margin: 0 auto;\n  padding-bottom: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.pagina-clientes .titulo {\n  text-align: center;\n  margin-top: 0px;\n  margin-bottom: 2px;\n}\n\n.pagina-clientes .botonessuperiores {\n  display: flex;\n  justify-content: center;\n  gap: 5px;\n  margin-bottom: 15px;\n}\n\n.pagina-clientes .botonessuperiores .p-button {\n  padding: 5px 10px;\n  font-size: 14px;\n}\n\n/* [EXPERT] Estabilidad y Altura Fija */\n.pagina-clientes .p-datatable .p-datatable-wrapper {\n  min-height: 400px;\n}\n\n.pagina-clientes .p-datatable .p-datatable-thead > tr > th {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.35rem !important;\n}\n\n.pagina-clientes .p-datatable .p-datatable-tbody > tr > td {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.3rem !important;\n  height: 38px !important; /* Altura firme alineada con el resto de la app */\n}\n\n/* ============================================\n   MEDIA QUERIES - RESPONSIVIDAD\n   ============================================ */\n\n/* === TABLETS (1024px y menores) === */\n@media (max-width: 1024px) {\n  .pagina-clientes.contenedorprincipal {\n    width: 98%;\n  }\n\n  .pagina-clientes .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.8rem;\n    padding: 0.25rem !important;\n  }\n\n  .pagina-clientes .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.85rem;\n    padding: 0.25rem !important;\n    height: 36px !important;\n  }\n}\n\n/* === MÓVILES (768px y menores) === */\n@media (max-width: 768px) {\n  .pagina-clientes.contenedorprincipal {\n    width: 100%;\n    padding: 5px;\n  }\n\n  .pagina-clientes .titulo {\n    font-size: 1.2rem;\n  }\n\n  .pagina-clientes .botonessuperiores {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .pagina-clientes .botonessuperiores .p-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .pagina-clientes .p-datatable-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* === MÓVILES PEQUEÑOS (480px y menores) === */\n@media (max-width: 480px) {\n  .pagina-clientes .titulo {\n    font-size: 1rem;\n  }\n\n  .pagina-clientes .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.75rem;\n  }\n\n  .pagina-clientes .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.75rem;\n    height: 32px !important;\n  }\n}\n\n/* Selección de fila */\n.pagina-clientes .p-datatable .p-datatable-tbody > tr.p-highlight {\n  background-color: #e0f7fa !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
